import type { AuthUser } from '@/types/auth/authTypes';

import { resolveWorkspaceId } from './workspace';

type CreateCustomFieldInputLike = {
  key: string;
  escritorioId?: string | null;
};

type WorkspaceUserLike = Pick<AuthUser, 'escritorioId'> | null | undefined;

const normalizeCustomFieldKey = (raw: string): string =>
  raw
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

export function withNormalizedCustomFieldPayload<T extends CreateCustomFieldInputLike>(
  data: T,
  user?: WorkspaceUserLike,
): T {
  const escritorioId = resolveWorkspaceId({
    explicitWorkspaceId: data.escritorioId,
    user,
  });

  return {
    ...data,
    key: normalizeCustomFieldKey(data.key),
    escritorioId,
  };
}
